import axiosInstance from "../../../../shared/api/axiosInstance.js";
import { baseUrl, DELETE_BOOTH, EDIT_BOOTH, CREATE_BOOTH } from "../../../../shared/api/endpoints.js";
import { configReq } from "../../../../shared/lib/functions.js";
/** Keeps the existing DELETE request and response contract. */
export function deleteBooth(data, token) {
  return axiosInstance.delete(`${baseUrl}/${DELETE_BOOTH}?id=${data.id}`, configReq(token));
}

/** Keeps the existing PUT request and response contract. */
export function editBooth(formData, token) {
  return axiosInstance.put(`${baseUrl}/${EDIT_BOOTH}`, formData, configReq(token, true));
}

/** Keeps the existing POST request and response contract. */
export function createBooth(formData, token) {
  return axiosInstance.post(`${baseUrl}/${CREATE_BOOTH}`, formData, configReq(token));
}
